import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientQueriesThunk } from '../features/queries/queryThunks';
import { useNavigate } from 'react-router-dom';
import '../CSS/TriggerAlertsTable.css';

const TriggerAlertsTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { queries, loading, error, next, count } = useSelector((state) => state.queries);
  const [page, setPage] = useState(0);
  const limit = 5; // Number of items to display per page

  useEffect(() => {
    // Initial fetch of client queries
    dispatch(fetchClientQueriesThunk({ limit }));
  }, [dispatch]);

  // Function to handle viewing all queries or loading more
  const handleViewAll = () => {
    if (next) {
      const offset = page * limit + limit;
      dispatch(fetchClientQueriesThunk({ offset, limit }));
      setPage(page + 1);
    }
  };

  // Function to format date to "12 Jan" format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    
    return `${day} ${month}`;
  };

  // Function to capitalize the first letter of each word
  const capitalizeText = (text) => {
    if (!text) return '';
    return text.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  };

  return (
    <div className="ta-trigger-alerts-container">
      <div className="ta-trigger-alerts-header">
        <h2 className="ta-trigger-alerts-title">Client Queries</h2>
        <button 
          className="ta-trigger-alerts-view-all" 
          onClick={() => navigate('/clientqueriestable')}
          disabled={loading && !queries.length}
        >
          {loading && !queries.length ? 'Loading...' : 'View all'}
        </button>
      </div>

      {/* Table header */}
      <div className="ta-trigger-alerts-table-header">
        <div className="ta-table-header-cell ta-store-col">Store Name</div>
        <div className="ta-table-header-cell ta-query-type-col">Query Type</div>
        <div className="ta-table-header-cell ta-subject-col">Subject</div>
        <div className="ta-table-header-cell ta-date-col">Date</div>
        <div className="ta-table-header-cell ta-status-col">Status</div>
      </div>

      <div className="ta-trigger-alerts-content">
        {loading && queries.length === 0 ? (
          <div className="ta-loading-message">Loading client queries...</div>
        ) : error ? (
          <div className="ta-error-message">{error}</div>
        ) : queries.length === 0 ? (
          <div className="ta-empty-message">No client queries available</div>
        ) : (
          queries.map((query) => (
            <div key={query.id} className="ta-trigger-alert-row">
              <div className="ta-store-info ta-store-col">
                {query.store && query.store.image ? (
                  <img 
                    src={query.store.image} 
                    alt={query.store?.store_name || 'Store'} 
                    className="ta-store-avatar"
                  />
                ) : (
                  <div className="ta-store-avatar ta-avatar-purple">
                    {query.store?.store_name?.[0] || '?'}
                  </div>
                )}
                <span className="ta-store-name">{query.store?.store_name || 'Unknown Store'}</span>
              </div>
              <div className="ta-alert-reason ta-query-type-col">
                {capitalizeText(query.query_type)}
              </div>
              <div className="ta-solved-by ta-subject-col">
                {query.subject}
              </div>
              <div className="ta-solved-by ta-date-col">
                {formatDate(query.incident_date)}
              </div>
              <div className="ta-alert-status ta-status-col">
                <span className="ta-status-badge">
                  {capitalizeText(query.status)}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
      
      {loading && queries.length > 0 && (
        <div className="ta-loading-more">Loading more...</div>
      )}
    </div>
  );
};

export default TriggerAlertsTable;